/**
 * Signup — the one flow with no session, because the account does not exist yet.
 */
import type {
  ConfirmVerificationRequest,
  ResendVerificationRequest,
  SignupResult,
  StartVerificationRequest,
  VerificationTicket,
} from "@ondo/shared";

import { publicPost } from "./request.ts";

/** Starts a signup: stores the details and sends a code to the address. */
export const startSignupVerification = (details: StartVerificationRequest) =>
  publicPost<VerificationTicket>("/signup/verification", details);

export const resendSignupVerification = (body: ResendVerificationRequest) =>
  publicPost<VerificationTicket>("/signup/verification/resend", body);

/**
 * Exchanges a correct code for an account. This is the call that creates the
 * user — nothing before it has touched auth.users.
 */
export const confirmSignupVerification = (body: ConfirmVerificationRequest) =>
  publicPost<SignupResult>("/signup/verification/confirm", body);
